import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=2477b27a&scoped=true&"
import script from "./TemplateEdit.vue?vue&type=script&lang=ts&"
export * from "./TemplateEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2477b27a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
